import axios from "axios";
import * as env from "../config/env";
const baseUrl = `${env.url}/stats/sp`;
const OP_USER_TOKEN = `${env.OP_USER_TOKEN}`;
const headers = {
  "User-Token": env.userToken,
};

export function getOrders() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/orders`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getOrderItems() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/orderItems`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getOrdersDueToday() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/dueToday?day=${"today"}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getOrdersDueTmrw() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/dueToday?day=${"tmrw"}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getItemsDueToday() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/itemsDue?day=${"today"}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getItemsDueTmrw() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/itemsDue?day=${"tmrw"}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getLateOrders() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/lateOrders`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getLateItems() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/lateItems`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getOrdersShipped() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/ordersShipped`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getItemsShipped() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/itemsShipped`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getOrdersBySku() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/ordersBySku`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getCanceledOrders() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/canceled`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getShipErrors() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/shipError`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getOrderCycle() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/cycle`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getPrelimLines(timeFrame) {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/lines?time=${timeFrame}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getPopularLocation(timeFrame, location) {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/locations?time=${timeFrame}&location=${location}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getArtwork(barcode) {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/artwork?barcode=${barcode}&token=${OP_USER_TOKEN}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getPrelimItemLines(timeFrame) {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/itemLines?time=${timeFrame}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getDailyReport() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/dailyReport`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getSkuShipped(data) {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/skuShipped?time=${data.time}&sku=${data.sku}`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

// --- Modern /subprint/orders report endpoints (mirrors openprintStats.service.js) ---

export function getOpenOrdersSummary() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/orderSummary`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

function fetchOrdersReport(endpoint, { search = '', page = 1, per_page = 50, date = null, box_size = null } = {}) {
  const config = { headers };
  const payload = { search, page, per_page };
  // Narrows the Mug Box Requirements detail tab to a single due date/box size.
  if (date) payload.date = date;
  if (box_size) payload.box_size = box_size;
  return axios
    .post(`${baseUrl}/${endpoint}`, payload, config)
    .then(responseSuccessHandler)
    .catch(responseErrorHandler);
}

export function getAllOrdersReport(options = {}) {
  return fetchOrdersReport('allOrders', options);
}

export function getTotalLateOrdersReport(options = {}) {
  return fetchOrdersReport('totalLateOrders', options);
}

export function getShippedTodayReport(options = {}) {
  return fetchOrdersReport('shippedToday', options);
}

export function getDueNextBusinessDayReport(options = {}) {
  return fetchOrdersReport('dueNextBusinessDay', options);
}

export function getShipErrorsReport(options = {}) {
  return fetchOrdersReport('shipErrors', options);
}

// Backs the Upcoming Mug Box Requirements card. Response shape: { mug: { dates: [...] } }
// — nested the same way as OP's combined mug+puzzle endpoint, even though SubPrint has
// no puzzle equivalent, so shared frontend logic between the two pages stays consistent.
export function getBoxRequirements() {
  const config = {
    method: "GET",
    headers
  };
  return axios.get(`${baseUrl}/boxRequirements`, config).then(responseSuccessHandler).catch(responseErrorHandler);
}

export function getMugBoxOrdersReport(options = {}) {
  return fetchOrdersReport('mugBoxOrders', options);
}

const responseSuccessHandler = response => {
  return response.data;
};
  
const responseErrorHandler = error => {
  console.log(error);
  return Promise.reject(error);
};